<template>
    <div class="newPage">
        <div class="content">
            <div v-if="tableData">
                <el-table v-loading="loading"
                          :data="tableData.list"
                          size="small"
                >

                    <el-table-column
                            prop="createTime"
                            label="创建时间"
                           >
                    </el-table-column>

                    <el-table-column
                            label="所属省份"
                            prop="province"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="city"
                            label="所属城市"
                    >
                    </el-table-column>


                    <el-table-column
                            label="数据类型"
                    >
                        <template slot-scope="scope">
                            <div> {{scope.row.mapperTable.name}}</div>
                        </template>
                    </el-table-column>



                    <el-table-column
                            label="当前进度"
                    >
                        <template slot-scope="scope">
                            <el-tag  size="small" v-if="scope.row.currentStep==='stepImport'">已导入</el-tag>
                            <el-tag  size="small" v-if="scope.row.currentStep==='stepFileUpload'" type="success">字段映射</el-tag>
                            <el-tag  size="small" v-if="scope.row.currentStep==='stepFieldMapping'" type="success">数据导入</el-tag>
                            <el-tag  size="small" v-if="scope.row.currentStep==='stepSelect'" type="success">文件上传</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column
                            prop="updateTime"
                            label="更新时间"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="createUserName"
                            label="创建人"
                    >
                    </el-table-column>
                    <el-table-column
                            width="200"
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="getInfo(scope.row.id)">查看详情</el-button>
                            <el-button type="text" size="small" @click="getHInfo(scope.row.id)">操作记录</el-button>
                            <el-button  v-if="scope.row.currentStep==='stepImport'" type="text" size="small" @click="delItem(scope.row.id)">删除数据</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <pagination
                    v-show="tableData.totalCount>queryParams.pageSize"
                    :total="tableData.totalCount"
                    :page.sync="queryParams.page"
                    :limit.sync="queryParams.pageSize"
                    @pagination="getList"
            />
        </div>

        <el-dialog
                title="详情"
                :visible.sync="detailVis"
                >
            <div class="dialogMapping" >
                <step-detail ref="stepDetail" :info-data="infoData"></step-detail>
            </div>

        </el-dialog>


        <el-dialog
                title="操作记录"
                :visible.sync="operationVis"
                :before-close="handleClose">
            <div class="dialogMapping" >
                <el-table
                        :data="operationData.list"
                        style="width: 100%">
                    <el-table-column
                            prop="operationUserName"
                            label="操作者"
                           >
                    </el-table-column>
                    <el-table-column
                            prop="operationTime"
                            label="操作时间"
                            width="200"
                    >
                    </el-table-column>
                    <el-table-column
                            prop="step"
                            label="操作步骤">
                        <template slot-scope="scope">
                            <el-tag  size="small" v-if="scope.row.step==='stepSelect'"  type="success">参数选择</el-tag>
                            <el-tag  size="small" v-if="scope.row.step==='stepFileUpload'" type="success">文件上传</el-tag>
                            <el-tag  size="small" v-if="scope.row.step==='stepFieldMapping'" type="success">字段映射</el-tag>
                            <el-tag  size="small" v-if="scope.row.step==='stepImport'" type="success">数据导入</el-tag>
                        </template>

                    </el-table-column>
                    <el-table-column
                            label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" v-if="scope.row.step !== 'stepImport'" size="small" @click="getoperationInfo(scope.row.id)">详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <pagination
                        v-show="operationData.totalCount>queryHParams.pageSize"
                        :total="operationData.totalCount"
                        :page.sync="queryHParams.page"
                        :limit.sync="queryHParams.pageSize"
                        @pagination="getHList"
                />
            </div>
        </el-dialog>


    </div>
</template>

<script>
    import url from "../../../utils/UrlApi"
    import StepDetail from "./component/stepDetail";

    export default {
        name: "list",
        components: {StepDetail},
        data(){
            return {
                loading:false,
                tableData:{
                    list:[],
                    totalCount:0,
                },
                queryParams:{
                    page:1,
                    pageSize:10
                },
                queryHParams:{
                    page:1,
                    pageSize:10
                },

                operationVis:false,
                operationData:{
                    list:[],
                    totalCount:0
                },

                detailVis:false,

                infoData:{},
            }
        },
        mounted(){
          this.getList()
        },
        methods:{
            getList(){
                let data =this.queryParams
                this.$http.get(url.mapperOperationpage, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.tableData = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getHInfo(id){
                this.queryHParams.RecordId = id

                this.getHList()
            },

            getHList(){
                let data =this.queryHParams
                this.$http.get(url.mapperOperationinfoPage, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.operationData = res.data.data
                        this.operationVis = true
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getInfo(id){

                this.$http.get(url.mapperOperationinfo+id).then(res => {
                    if (res.data.code === '200') {
                       // console.log(res)
                        this.detailVis = true
                        this.infoData = res.data.data

                        setTimeout(()=>{
                            this.$refs['stepDetail'].activeName = 'stepSelect'
                        })

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            getoperationInfo(id){
                this.$http.get(url.mapperOperationinfoPage2+id).then(res => {
                    if (res.data.code === '200') {
                        this.detailVis = true
                        this.infoData = res.data.data.details

                        setTimeout(()=>{
                            this.$refs['stepDetail'].activeName = res.data.data.details.currentStep
                        })

                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            delItem(id){


                this.$confirm('确定删除此笔数据吗?', '提示', {
                    confirmButtonText: '删除',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let data ={
                        id:id
                    }
                    this.$http.post(url.mapperOperationdel, data).then(res => {
                        if (res.data.code === '200') {
                            this.getList()
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                }).catch(() => {

                });

            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
        }
    }
</script>

<style scoped lang="less">
    .newPage{
        .content{
            padding: 10px;
        }
    }
</style>
